export default {
  ERROR: "error",
  WARNING: "warning",
  LOG: "log",
  TIMEOUT: "timeout",
  UNACCESSED: "unaccessed",
};
